import axios from 'axios';
import {DqResponseTO} from 'generated/JavaTO'

interface Args {
	dqkey: string
	params?: { [key in string]: any }
	filter?: string | number
	url?: string
	isAze?: boolean
}

/**
 *  use parser functions from DqParser.ts to retrieve elements!
 */
export function fetchDqAPI({dqkey, params, filter, url = '../json/aacf', isAze}: Args) {
	return axios.request<DqResponseTO>({
		url,
		method: 'POST' as const,
		data: {
			id: dqkey,
			filter,
			params,
			...(isAze ? {isAze: true} : {}),
		},
	})
}